// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-standards/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springStandardsEN: PageEntry = {
  id: "post.federnormen",
  locale: "en",
  slug: "spring-standards",
  seo: {
    title: "Glossary: Spring standards simply explained | Dietz GmbH",
    description: "Spring standards are standardised guidelines and specifications that regulate the manufacture, quality and use of springs. These standards are defined by international organisation",
  },
  type: "post",
  h1: "Glossary: Spring standards simply explained",
  intro: "Spring standards are standardised guidelines and specifications that regulate the manufacture, quality and use of springs. These standards are defined by international organisations such as the ISO (International Organization for Standardisation) or national standardisation bodies. They include parameters such as material properties, spring dimensions, load requirements and test methods. Compliance with spring standards is crucial to ensure the interoperability, safety and quality of springs in various industries.",
  blocks: [

  ],
};
